'use strict';

module.exports = {"ENV":"dev","WEBSOCKET_URL":"wss://big2-api-dev-summer.herokuapp.com/game"};
